export enum TextBoxType {
  Text = 'text',
  Password = 'password',
  Email = 'email'
}
